import React, { useState } from "react";
import { AppBar, Toolbar, Typography, Box, IconButton, Avatar, Tooltip, Menu, MenuItem, Divider, ListItemIcon } from "@mui/material";
import { LogoutCurve, Menu as MenuIcon, UserEdit, Lock } from "iconsax-react";
import { useNavigate } from "react-router-dom";

const AdminNavbar = ({ onLogout, login, onDrawerToggle }) => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenuItemClick = (path) => {
        navigate(path);
        handleClose();
    };

    return (
        <AppBar
            position="fixed"
            sx={{
                background: "rgba(255, 255, 255, 0.7)",
                backdropFilter: "blur(20px)",
                boxShadow: "0 4px 30px rgba(0, 0, 0, 0.03)",
                borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
                zIndex: (theme) => theme.zIndex.drawer + 1,
                width: { xs: "calc(100% - 40px)", md: "calc(100% - 140px)" }, // Responsive width
                left: { xs: "20px", md: "120px" }, // Responsive left offset
                top: "20px",
                right: "20px",
                borderRadius: "20px",
                mx: "auto",
                transition: "all 0.3s ease-in-out",
            }}
            elevation={0}
        >
            <Toolbar sx={{ justifyContent: "space-between", minHeight: "70px" }}>

                {/* Left Side: Hamburger (Mobile) + Brand */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={onDrawerToggle}
                        sx={{ mr: 2, display: { md: "none" }, color: "#333" }}
                    >
                        <MenuIcon size="24" />
                    </IconButton>

                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 800,
                            background: "linear-gradient(45deg, #1a237e 30%, #0d47a1 90%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            letterSpacing: "0.5px",
                            display: { xs: "none", sm: "block" }
                        }}
                    >
                        Admin Dashboard
                    </Typography>
                </Box>

                {/* Actions */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>

                    {/* Profile Dropdown */}
                    <Tooltip title="Account Settings">
                        <Box
                            onClick={handleClick}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                background: "rgba(255,255,255,0.5)",
                                padding: "5px 15px 5px 5px",
                                borderRadius: "50px",
                                border: "1px solid rgba(0,0,0,0.05)",
                                cursor: "pointer",
                                transition: "0.2s",
                                "&:hover": {
                                    background: "rgba(255,255,255,0.8)",
                                    transform: "translateY(-2px)",
                                    boxShadow: "0 4px 15px rgba(0,0,0,0.05)"
                                }
                            }}
                        >
                            <Avatar
                                alt="Admin"
                                src={login?.profileImage || ""}
                                sx={{ width: 40, height: 40, border: "2px solid #fff" }}
                            />
                            <Box sx={{ display: { xs: "none", md: "block" } }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#333" }}>
                                    {login?.name || "Administrator"}
                                </Typography>
                                <Typography variant="caption" sx={{ color: "#777" }}>
                                    Super Admin
                                </Typography>
                            </Box>
                        </Box>
                    </Tooltip>

                    <Menu
                        anchorEl={anchorEl}
                        id="account-menu"
                        open={open}
                        onClose={handleClose}
                        onClick={handleClose}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 10px 30px rgba(0,0,0,0.1))',
                                mt: 1.5,
                                borderRadius: "16px",
                                minWidth: "200px",
                                '& .MuiAvatar-root': {
                                    width: 32,
                                    height: 32,
                                    ml: -0.5,
                                    mr: 1,
                                },
                            },
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >
                        <MenuItem onClick={() => handleMenuItemClick('/editProfile')}>
                            <ListItemIcon>
                                <UserEdit size="20" variant="Bold" color="#555" />
                            </ListItemIcon>
                            Profile
                        </MenuItem>
                        <MenuItem onClick={() => handleMenuItemClick('/change-password')}> {/* Placeholder link */}
                            <ListItemIcon>
                                <Lock size="20" variant="Bold" color="#555" />
                            </ListItemIcon>
                            Change Password
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => { handleClose(); onLogout(login?.token); }} sx={{ color: "#d32f2f" }}>
                            <ListItemIcon>
                                <LogoutCurve size="20" variant="Bold" color="#d32f2f" />
                            </ListItemIcon>
                            Logout
                        </MenuItem>
                    </Menu>

                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default AdminNavbar;
